export const $t = (localeString: string, params: any = null) => {
  const { $i18n } = useNuxtApp()
  const t = $i18n.t

  return t(localeString, params)
}
